export const TEMPORARY_SUBFOLDER_NAME = "__$$temporary_subfolder$$__";
